import React from 'react';
import { PlaygroundProjectContainer, StyledPlayground } from '../../Styled/playgraund/playground.style';
import { SectionHeading, SectionTitle } from '../../Styled/sectionheading/sectionheading.style';
import CardService from './CardService';
import { FaCode, FaLaptopCode, FaMobileAlt, FaWordpress } from 'react-icons/fa';

const Service = () => {
  const data = [
    {
      title: 'Vibe Coding Sprint Rooms',
      eyebrow: 'Realtime collab',
      images: <FaCode />,
      description: 'Pair with founders live, remix hero flows, and lock in dopamine-heavy motion before the design files are even exported.',
      stack: 'React • GSAP • Lottie',
    },
    {
      title: 'Next.js Launch Kits',
      eyebrow: 'Edge native',
      images: <FaLaptopCode />,
      description: 'Ship Next.js 14 experiences with streaming, Route Handlers, and analytics baked-in for drop-ready performance.',
      stack: 'Next.js 14 • Vercel Edge',
    },
    {
      title: 'MERN Flow Ops',
      eyebrow: 'Scale mode',
      images: <FaMobileAlt />,
      description: 'Full-stack systems with auth, gated dashboards, and queue-backed notifications ready for rapid iteration.',
      stack: 'Mongo • Express • React • Node',
    },
    {
      title: 'Creator-friendly WordPress',
      eyebrow: 'No-code ally',
      images: <FaWordpress />,
      description: 'Custom blocks, fast hosting, and growth tooling so content teams can ship culture drops without dev waitlists.',
      stack: 'WordPress • Headless APIs',
    },
  ];

  return (
    <StyledPlayground id="playground">
      <SectionHeading>
        <SectionTitle number="03">Service</SectionTitle>
      </SectionHeading>

      <PlaygroundProjectContainer>
        {data.map((item) => (
          <CardService
            key={item.title}
            title={item.title}
            description={item.description}
            images={item.images}
            eyebrow={item.eyebrow}
            stack={item.stack}
            animation="zoom-out-right"
          />
        ))}
      </PlaygroundProjectContainer>
    </StyledPlayground>
  );
};

export default Service;